import React from "react";
import PropTypes from "prop-types";
import formField from "../formField";

export function TextArea({
  input,
  type = "text",
  className,
  rows = "10",
  cols = "40",
  maxLength = 1000,
  autoFocus = false,
  disabled = false
}) {
  return (
    <textarea
      type={type}
      id={input.name}
      rows={rows}
      cols={cols}
      maxLength={maxLength}
      autoFocus={autoFocus}
      className={`form-control ${className}`}
      disabled={disabled}
      style={{ resize: "none" }}
      {...input}
    />
  );
}

export default formField(TextArea);

TextArea.propTypes = {
  input: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  className: PropTypes.string,
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  cols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormInput/TextArea.jsx